import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=79c99100&scoped=true"
import script from "./PdfViewer.vue?vue&type=script&lang=ts"
export * from "./PdfViewer.vue?vue&type=script&lang=ts"
import style0 from "./PdfViewer.vue?vue&type=style&index=0&id=79c99100&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c99100",
  null
  
)

export default component.exports